import { Progress } from "./ui/progress";
import { fmtNum } from "../lib/format";

export const ParsingProgress = ({ file, progress, rows, saving }) => (
  <div className="max-w-3xl mx-auto px-6 pt-32 fade-up" data-testid="parsing-progress">
    <p className="label-mono mb-3">Step 3 · Streaming parse</p>
    <h2 className="font-display text-3xl font-bold text-slate-100 truncate">{file?.name}</h2>
    <div className="mt-10 panel p-8">
      <div className="flex items-end justify-between mb-4">
        <span className="font-mono text-5xl text-slate-100" data-testid="parsing-percent">{progress}%</span>
        <span className="font-mono text-sm text-slate-400" data-testid="parsing-rows">{fmtNum(rows)} rows</span>
      </div>
      <Progress value={progress} data-testid="csv-parsing-progress-bar" className="h-2 bg-slate-800" />
      <p className="mt-4 text-xs text-slate-500">{saving ? "Saving summary to the server…" : "Processing locally in 4 MB chunks…"}</p>
    </div>
  </div>
);
